export default __webpack_public_path__ + "static/reclaimation-process-829f88305ef1c5adc1270b502337fe24.png";